import React, { useState, useEffect } from 'react';


const SliderProjects = () => {
    const [data, setData] = useState([])

    useEffect(() => {
        fetch("/project.json")
            .then(res => res.json())
            .then(data => setData(data))

    }, [])

    return (
        <div className='py-2'>
          
           <div className="pscontainer">
            <div className="slide-container">
             
             
                    {data?.map((project) => (
                        <>
                            <a target="_blank" href={project.live}>
                                <div className="slide-image">
                                    <img src={project.img} alt="" />

                                </div>
                            </a>

                        </>
                    ))}
            
                
               
              
               
               
                
            </div>
                
            </div> 
        </div>
    );
};

export default SliderProjects;